import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'color-swatch-button',
  styleUrl: 'color-swatch-button.css',
})
export class ColorSwatchButton {
  @Prop() isActive: boolean;
  @Prop() label: string;
  @Prop() colorHex: string;

  render() {
    const classNames = {
      'color-swatch-button': true,
      'color-swatch-button--selected': this.isActive,
    };

    return (
      <button class={classNames}>
        <div class="color-swatch-button__color-box" style={{ background: this.colorHex }}></div>

        <div class="color-swatch-button__label">{this.label}</div>
      </button>
    );
  }
}
